<template>
    <v-dialog v-model="dialog" width="600" scrollable>
        <v-card :disabled="load">
            <v-card-title class="pb-2">
                Asignar ticket
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                    <v-icon>fas fa-times</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="pt-6">
                <v-form ref="form">
                    <v-row>
                        <!-- 
                        USUARIO
                        PRIORIDAD
                         -->
                        <v-col cols="6" sm="6" md="6" class="py-0">
                            <v-autocomplete v-model="data.usuario" label="Usuario" item-text="Username"
                                item-value="Usuario_id" :items="usuarios" :rules="[rules.required]" validate-on-blur
                                autofocus outlined dense></v-autocomplete>
                        </v-col>
                        <v-col cols="6" sm="6" class="py-0">
                            <v-autocomplete v-model="data.prioridad" label="Prioridad" item-text="nombre"
                                item-value="prioridad_id" :items="prioridades" outlined dense
                                clearable></v-autocomplete>
                        </v-col>

                        <v-col v-if="!ticket?.tipo_ticket_id"  cols="6" sm="6" md="6" class="py-0">
                            <v-autocomplete v-model="data.tipo_ticket" label="Tipo" item-text="nombre"
                                item-value="tipo_id" :items="tipos_tickets" :rules="[rules.required]" validate-on-blur
                                autofocus outlined dense></v-autocomplete>
                        </v-col>

                        <v-col v-if="!ticket?.area_id" cols="6" sm="6" md="6" class="py-0">
                            <v-autocomplete v-model="data.area" label="Area" item-text="nombre"
                                item-value="area_id" :items="areas" :rules="[rules.required]" validate-on-blur
                                autofocus outlined dense></v-autocomplete>
                        </v-col>

                        <v-col v-if="!ticket?.origen_id"  cols="6" sm="6" md="6" class="py-0">
                            <v-autocomplete v-model="data.origen" label="Origen" item-text="nombre"
                                item-value="origen_id" :items="origenes" :rules="[rules.required]" validate-on-blur
                                autofocus outlined dense></v-autocomplete>
                        </v-col>

                        <v-col cols="12" class="py-0">
                            <v-textarea placeholder="Comentario interno" v-model="data.comentario" rows="3"
                                validate-on-blur outlined dense></v-textarea>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                            <FileDropzone :files="archivos"
                                :tipos="['.txt', '.png', '.jpg', '.webp', '.doc', '.docx', '.csv', '.xls', '.xlsx', '.pdf']"
                                :multiple="true" :max_size="25" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-end pb-4">
                <v-btn color="error" class="mr-3" :disabled="load" @click="dialog = false">
                    Cancelar
                </v-btn>
                <BtnConfirmar nombre="Asignar" :loading="load" @action="guardar()" />
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { getBase64 } from '../../util/utils'
import BtnConfirmar from '../util/BtnConfirmar.vue';
import FileDropzone from '../util/FileDropzone.vue';
import { convertImageToWebp } from '../../util/imagenes';

export default {
    data() {
        return {
            load: false,
            local: null,
            rules: {
                required: value => !!value || 'Campo requerido'
            },
            data: {
                usuario: null,
                estado: 2,
                prioridad: null,
                comentario: '',
                es_comentario_interno: 1,
                tipo_ticket: null,
                area: null,
                origen: null
            },

            archivos: [],
            archivos_adjuntos: [],
        }
    },

    props: {
        value: Boolean,
        usuarios: {
            type: Array,
            default: []
        },

        prioridades: {
            type: Array,
            default: []
        },

        ticket: {
            type: Object,
            default: {}
        },
        areas: {
            type: Array,
            default: []
        },
        tipos_tickets: {
            type: Array,
            default: []
        },
        origenes: {
            type: Array,
            default: []
        }
    },

    async created() {

    },
    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    components: {
        BtnConfirmar,
        FileDropzone
    },
    watch: {
        dialog(val) {
            if (val) {

                this.data = {
                    usuario: this.ticket?.usuario_asignado,
                    es_comentario_interno: 1,
                    comentario: '',
                    estado: 2,
                    prioridad: this.ticket?.prioridad_id,
                    tipo_ticket: this.ticket.tipo_ticket_id,
                    area: this.ticket.area_id,
                    origen: this.ticket.origen_id
                }
            } else {
                this.data = {
                    usuario: null,
                    estado: 2,
                    prioridad: null,
                    comentario: '',
                    es_comentario_interno: 1,
                    area: null,
                    origen: null,
                    tipo_ticket: null,
                }
            }
        },
    },
    methods: {
        async guardar() {
            this.$store.state.loading = true
            if (this.$refs.form.validate()) {
                // valido si en algun lado de la descripcion puso adjunto para avisarle por si no adjuntó nada
                const tiene_adjunto = this.data.comentario.toLowerCase().indexOf('adjunto') >= 0
                const tiene_archivo = this.data.comentario.toLowerCase().indexOf('archivo') >= 0
                if ((tiene_adjunto || tiene_archivo) && this.archivos.length == 0) {
                    let ups_me_olvide_el_archivo = false
                    await this.$swal.fire({
                        icon: 'warning',
                        html: `Se encontró la palabra <strong>${tiene_archivo ? 'archivo' : ''} ${tiene_adjunto ? 'adjunto' : ''}</strong> en el cuerpo del mensaje
              pero no se seleccionó ningún archivo.<div style="font-size: 20px; margin-top: 12px"><strong>¿Desea cargar el incidente de todas formas?</strong></div>`,
                        confirmButtonText: 'Sí, cargar de todas formas',
                        denyButtonText: 'No, seleccionar archivos',
                        denyButtonColor: '#3085d6',
                        showDenyButton: true,
                        focusDeny: true
                    })
                        .then((res) => {
                            // si pone que no o hace click fuera del modal no hace nada
                            if (!res.isConfirmed) {
                                ups_me_olvide_el_archivo = true
                            }
                        })
                    if (ups_me_olvide_el_archivo) return
                }



                this.load = true


                await this.$store.dispatch('tickets/asignarTicket', {
                    ...this.data,
                    ticket_id: this.ticket?.ticket_id
                }).then(async res => {
                    if (res.exito) {
                        await this.enviarComentarioYArchivos(res.message)
                        this.dialog = false
                        this.$emit('actualizarTicket', res.data)
                        this.$emit('actualizar')
                    } else {
                        this.$store.dispatch('show_snackbar', {
                            text: res.message,
                            color: 'error'
                        })
                    }
                }).catch(error => {
                    this.$store.dispatch('show_snackbar', {
                        text: error.message,
                        color: 'error'
                    })
                })
                this.load = false
            }
            this.$store.state.loading = false
        },




        async enviarComentarioYArchivos(mensaje) {

            let comentario = this.data.comentario
            let archivos = []
            const nombreArchivos = []
            if (this.archivos.length > 0) {
                for (const archivo of this.archivos) {
                    // Convertir a WebP si es imagen, o dejar el archivo original si no lo es
                    const archivoConvertido = await convertImageToWebp(archivo);
                    // Agregar el nombre del archivo convertido (con extensión .webp si aplicó)
                    nombreArchivos.push(archivoConvertido.name);
                    // Convertir a base64
                    const fileBase64 = await getBase64(archivoConvertido);
                    archivos.push(fileBase64);
                }
            }

            if (comentario) {
                await this.envar_comentario(comentario, mensaje, archivos, nombreArchivos)
            } else {
                if (this.archivos.length > 0) {
                    // subir solo archivos
                    await this.envar_comentario('Se cargó un archivo adjunto.', mensaje, archivos, nombreArchivos)
                } else {
                    await this.$swal.fire({
                        icon: 'success',
                        title: mensaje,
                    })
                    return
                }
            }
        },

        async envar_comentario(comentario, mensaje, archivos, nombreArchivos) {

            await this.$store.dispatch('tickets/nuevoComentario', {
                id: this.ticket?.ticket_id,
                comentario: comentario,
                es_comentario_mesa: 1,
                usuario_nombre: `${this.$store.state.usuario.nombre} ${this.$store.state.usuario.apellido}`,
                estado_ticket_id: 2,
                es_comentario_interno: 1
            })
                .then(async (res) => {
                    if (res.exito) {
                        this.data.comentario = ''
                        this.$emit('actualizarComentario', res.data)

                        if (archivos.length === 0) {
                            //ESTO VER SI ENVIO PORQUE QUIERO ASIGNAR 
                            await this.$swal.fire({
                                icon: 'success',
                                title: mensaje,
                            })
                        } else {
                            await this.$store
                                .dispatch('tickets/cargarArchivos', {
                                    archivos,
                                    nombreArchivos,
                                    ticket_id: this.ticket?.ticket_id,
                                    estado_id: this.ticket?.estado_id,
                                    comentario_id: res.data.comentario_id
                                })
                                .then(resArchivos => {
                                    if (resArchivos.exito) {
                                        this.archivos_adjuntos = []
                                        resArchivos.data.forEach(archivo => {
                                            this.archivos.push(archivo)
                                        })
                                        if (resArchivos.feedbackFallidos.length > 0) {
                                            this.$swal.fire({
                                                icon: 'info',
                                                title: mensaje,
                                                html: `<strong>${resArchivos.feedbackFallidos}</strong>`,
                                                width: '450px'
                                            })
                                        } else {
                                            this.$swal.fire({
                                                icon: 'success',
                                                title: mensaje,
                                            })
                                        }
                                    } else {
                                        this.$store.dispatch('show_snackbar', {
                                            text: mensaje,
                                            color: 'error'
                                        })
                                    }
                                })
                        }
                    } else {
                        this.$store.dispatch('show_snackbar', {
                            text: mensaje,
                            color: 'error'
                        })
                    }
                })
                .catch(error => {
                    this.$store.dispatch('show_snackbar', {
                        text: error.message,
                        color: 'error'
                    })
                })

        },

        limpiar() {
            this.$refs.form.resetValidation()
        }
    }
}
</script>